import styled from "styled-components";
import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { StyledBasicLegendWrapper } from "app/pages/app-intelligence/app-analysis/components/GenericGraph/components/GenericChartLegend/styledComponents";

const { carbon, bluegrey, blue } = colorsPalettes;

export const LegendItemsContainer = styled.div<{ height: string; withoutHeaders?: boolean }>`
    overflow-y: hidden;
    height: ${({ height }) => height};
    ${({ withoutHeaders }) => withoutHeaders && "padding-right: 16px;"},
    &:hover {
        overflow-y: auto;
    }
    margin-top: 12px;
    .legends-container ${StyledBasicLegendWrapper}:last-child {
        padding-bottom: 20px;
    }
`;

export const SearchInputContainer = styled.div`
    padding-right: 16px;
    .SearchInput-container {
        height: 40px;
    }
    @media print {
        display: none;
    }
    .SearchInput-container .SearchInput {
        box-shadow: none;
        &:focus {
            background-color: ${bluegrey[100]};
            border: 1px solid ${blue[400]};
        }
        &:hover {
            box-shadow: 0px 3px 5px ${rgba(carbon[400], 0.12)};
        }
    }
`;

export const SelectedAttributes = styled.div`
    margin-bottom: 20px;
    display: block;
    ${setFontVariant("dataTable1", carbon[250])}
`;

export const OtherLegendsContainer = styled.div`
    padding-top: 8px;
    padding-right: 16px;
`;

export const TitlesContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding-right: 16px;
    margin-bottom: 10px;
`;

export const Title = styled.span`
    ${setFontVariant("captionTitle", carbon[400])};
`;

export const StyledLegendWrapper = styled.span`
    width: calc(100% - -4px);
    margin-bottom: 8px;
    padding-left: 4px;

    .winnerIcon {
        padding-top: 0;
    }
`;

export const HeaderContainer = styled.div`
    padding-left: 4px;
`;
